import FadeIn from "components/FadeIn";
import PropTypes from "prop-types";
import React from "react";

import {
  MessageTile,
  MessageTileButton,
  MessageTileHeader,
  ThemeSelector
} from "@theconversation/ui";

/**
 * The `ContentInline` component represents the inline promos that appears within
 * content body.
 */
function ContentInline({ body, buttonText, onClick, theme }) {
  return (
    <ThemeSelector theme={theme}>
      <MessageTile>
        <FadeIn>
          <MessageTileHeader>
            {body}
          </MessageTileHeader>
          <MessageTileButton onClick={onClick} fullWidth={false}>
            {buttonText}
          </MessageTileButton>
        </FadeIn>
      </MessageTile>
    </ThemeSelector>
  );
}

ContentInline.propTypes = {
  body: PropTypes.string.isRequired,
  buttonText: PropTypes.string,
  theme: PropTypes.oneOf(["accent", "core", "default"]),
  onClick: PropTypes.func.isRequired,
};

ContentInline.defaultProps = {
  theme: "core",
  donateText: "",
  buttonText: "",
};

export default ContentInline;
